import { Home } from '@/routes/Home';
import { ProjectDetail } from '@/routes/ProjectDetail';
import { ThreadManagement } from '@/routes/ThreadManagement';
import { ToolManagement } from '@/routes/ToolManagement';
import type { FC } from 'react';
import { Route, Routes } from 'react-router-dom';

const App: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/project/:projectId" element={<ProjectDetail />} />
      <Route path="/assemblies" element={<ToolManagement />} />
      <Route path="/threads" element={<ThreadManagement />} />
    </Routes>
  );
};

export default App;
